export default "__VITE_ASSET__02be3044__"